
import ProductTag from "@/models/ProductTag";
import Vue from "vue";
import { mapState } from "vuex";
export default Vue.extend({ 
  props: {
    item: {
      type: ProductTag,
      required: true
    },

    disabled: {
      type: Boolean,
      required: false      
    },

    fontSize: {
      required: false,
      default: "small",
      type: String
    },

    brandCard: {
      required: false,
      default: false,
      type: Boolean
    }
  },

  computed: {
    ...mapState("partner", ["partnerSettings", "appDataContent"])
  }

});
